module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMTAxLjE0IiB3aWR0aD0iMTYyNi4yNyI+PHBhdGggZmlsbD0iIzUyMjk1YyIgZD0iTTE2MjUuMyAxMDAuNjRoLTc1LjhMMTQ3OC41LjVoNzUuOHoiLz48cGF0aCBmaWxsPSIjMzIwZTNkIiBkPSJNMTU0OS41IDEwMC42NEguNVYuNWgxNDc4eiIvPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/styles/purple-stripes/left.svg
// module id = ./src/styles/purple-stripes/left.svg
// module chunks = 21